package com.dignicate.providers

import com.dignicate.web.data.ContentRepositoryImpl
import com.dignicate.web.domain.ContentRepository
import com.dignicate.web.domain.GetCompanyContentUseCase
import com.dignicate.web.domain.GetFooterNavUseCase
import com.dignicate.web.domain.GetMainPageContentUseCase
import com.dignicate.web.domain.GetNavigationLabelsUseCase
import com.dignicate.web.domain.GetPrivacyPolicyUseCase
import com.dignicate.web.domain.GetTermsUseCase
import com.dignicate.web.domain.Language
import com.dignicate.web.viewmodels.MainViewModel
import com.dignicate.web.viewmodels.PrivacyPolicyViewModel
import com.dignicate.web.viewmodels.TermsViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob

class AppGraph(locale: String?) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val language = if (locale != null) Language.fromCode(locale) else Language.System

    val contentRepository: ContentRepository = ContentRepositoryImpl()

    private val getMainPageContentUseCase = GetMainPageContentUseCase(contentRepository, language, scope)
    private val getNavigationLabelsUseCase = GetNavigationLabelsUseCase(contentRepository, language, scope)
    private val getCompanyContentUseCase = GetCompanyContentUseCase(contentRepository, language, scope)
    private val getFooterNavUseCase = GetFooterNavUseCase(contentRepository, scope)

    val mainViewModel = MainViewModel(
        getMainPageContentUseCase,
        getNavigationLabelsUseCase,
        getCompanyContentUseCase,
        getFooterNavUseCase
    )
    val termsViewModel = TermsViewModel(GetTermsUseCase(contentRepository))
    val privacyPolicyViewModel = PrivacyPolicyViewModel(GetPrivacyPolicyUseCase(contentRepository))
}
